<!--
/**
* @name: YSupplier.vue
* @description: 获取所有类型的经销商
* @author: wenyongjiang
* @create: 2020/08/03 09:15:21
* @update: 2020/08/03 09:15:21
*/
-->
<template>
  <k-select v-model="code" v-bind="pps">
    <k-option v-for="item in dataList" :key="item.code" :value="item.code" :label="item.name"
      :selected="code==item.code">{{item.name}}</k-option>
  </k-select>
</template>

<script>
  // import { XTL_USER_SERVER_SUPPLIER_GETBOX } from '@/assets/modules/apiList';

  let BASEDATA = [];
  export default {
    props: {
      block: Boolean,
      placeholder: {
        type: String,
        default: '请选择经销商'
      },
      value: [String, Number],
      nearby: {
        type: Boolean,
        default: true
      }
    },
    computed: {
      pps() {
        return {
          block: this.block,
          placeholder: this.placeholder,
          nearby: this.nearby
        };
      }
    },
    model: {
      prop: 'value',
      event: 'valueChange'
    },
    watch: {
      value: {
        immediate: true,
        handler(v) {
          this.code = v;
        }
      },
      code(v) {
        this.$emit('valueChange', v);
      }
    },
    data() {
      return {
        dataList: [],
        code: this.value
      };
    },
    created() {
      this.getSupplierList();
    },
    methods: {
      getSupplierList() {
        if (BASEDATA.length) {
          this.dataList = JSON.parse(JSON.stringify(BASEDATA));
        } else {
          this.$fetch({
            api: XTL_USER_SERVER_SUPPLIER_GETBOX,
            para: { levelCode: '' }
          }).then(data => {
            BASEDATA = data;
            this.dataList = data;
          });
        }
      }
    }
  };
</script>